import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import _FundFacts from './FundFacts';
import FundCommentary from './FundCommentary';
import Charts from './Charts';
import KeyDocuments from './KeyDocuments';
import Disclaimers from './Disclaimers';
import withColumns from './withColumns';

const FundFacts = withColumns(_FundFacts);

const FundCardColumns = styled<any, any>('div')`
    ${propStyles};
`;

FundCardColumns.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    bgColor: 'white',
};

const FundCardMain = styled<any, any>('div')`
    ${propStyles};
`;

FundCardMain.defaultProps = {
    flex: '0 1 100%',
    minWidth: '0',
    paddingX: ['sm', 'md', 'lg'],
    paddingY: ['sm', 'md', 'lg'],
};

const FundCardSidebar = styled<any, any>('div')`
    ${propStyles};
`;

FundCardSidebar.defaultProps = {
    width: '240px',
    flex: '0 0 auto',
    paddingX: ['md', 'lg'],
    paddingY: ['md', 'lg'],
};

@inject('dataStore')
@observer
class FundCardColumn extends Component<any, any> {
    @computed
    get chartsHeader() {
        const charts = this.props.dataStore.config.rowConfig.charts;
        if (charts && !Array.isArray(charts)) {
            return charts.label || '';
        }
        return '';
    }

    @computed
    get showSidebar() {
        const { fundManagers, keyDocuments, ratingImageStore } = this.props;
        return (
            fundManagers.length > 0 ||
            keyDocuments.length > 0 ||
            ratingImageStore.showComponent
        );
    }

    render() {
        const { chartsHeader, showSidebar } = this;

        const {
            theme,
            dataStore,
            shareClass,
            fundCardDisclaimers,
            queryContext,
            ratingImageComponent,
            keyDocumentsConfig,
            keyDocuments,
            charts,
            fundManagersComponent,
            fundCommentary,
            hasFundCommentary,
            fundFacts,
            ratingImageStore,
        } = this.props;

        return (
            <FundCardColumns {...theme.FundCardColumns}>
                <FundCardMain {...theme.FundCardMain}>
                    {hasFundCommentary && (
                        <FundCommentary
                            showHeading={true}
                            fundCommentary={fundCommentary}
                            shareClass={shareClass}
                        />
                    )}
                    {fundFacts && (
                        <FundFacts
                            dataStore={dataStore}
                            showHeading={true}
                            fundFacts={fundFacts}
                            shareClass={shareClass}
                        />
                    )}
                    {charts && (
                        <Charts
                            chartsHeader={chartsHeader}
                            charts={charts}
                            shareClass={shareClass}
                            queryContext={queryContext}
                        />
                    )}
                    <Disclaimers
                        disclaimers={fundCardDisclaimers}
                        theme={{
                            ...theme,
                            DisclaimersList: theme.FundCardDisclaimersList,
                            DisclaimerListItem:
                                theme.FundCardDisclaimerListItem,
                            DisclaimerCharacter:
                                theme.FundCardDisclaimerCharacter,
                            DisclaimerContent: theme.FundCardDisclaimerContent,
                        }}
                    />
                </FundCardMain>
                {showSidebar && (
                    <FundCardSidebar {...theme.FundCardSidebar}>
                        {ratingImageStore.ratingImagePosition ===
                            'aboveFundManager' && ratingImageComponent}
                        {fundManagersComponent}
                        {ratingImageStore.ratingImagePosition ===
                            'belowFundManager' && ratingImageComponent}
                        {keyDocuments.length > 0 && (
                            <KeyDocuments
                                showHeading={true}
                                keyDocumentsConfig={keyDocumentsConfig}
                                keyDocuments={keyDocuments}
                                shareClass={shareClass}
                                queryContext={queryContext}
                            />
                        )}
                    </FundCardSidebar>
                )}
            </FundCardColumns>
        );
    }
}

export default withTheme(FundCardColumn) as any;



// WEBPACK FOOTER //
// ./src/Components/FundCardColumn.tsx